import { PanelItem } from '../panel-item.class';

export const alignToBottomCfn = (panelItem: PanelItem): void => {
	const { panelItemGroup } = panelItem.refMap;
	if (panelItemGroup === null) return;

	const panelItems = panelItemGroup.items;

	// find item with lowest bottom point
	const bottom = panelItems.children.reduce((lowest: number | null, pi: { center: { y: number }; item: { size: { height: number } } }) => {
		const itemBottom = pi.center.y + (pi.item.size.height / 2);
		if (lowest === null) return itemBottom;
		return itemBottom > lowest ? itemBottom : lowest;
	}, null);

	if (bottom !== null) {
		panelItem.center.y = bottom - (panelItem.item.size.height / 2);
	}
	// 		panelItem.center.y = bottom - (panelItem.item.size.height / 2);
	// 	});
	// }
}

